import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8UserURL } from 'services/production/utils/getM8URL';

export const promocodeApplied = async (): Promise<boolean> => {
  const fetchURL = getM8UserURL('promocodeApplied');

  const response = await customFetch(fetchURL);

  if (!response.ok) {
    if (response.status === 404) {
      return false;
    }

    throw new HTTPResponseError(response);
  }

  return true;
};
